import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-short-loading',
  templateUrl: './short-loading.component.html',
  standalone: false,
})
export class ShortLoadingComponent {
  @Input() message: string = 'Loading...';
  @Input() centered: boolean = false;
}
